<template>
  <!-- NOTIFICATIONS -->
  <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
    <feather-icon
      icon="BellIcon"
      class="cursor-pointer mt-1 sm:mr-6 mr-2"
      :badge="unreadNotifications.length"
    />

    <vs-dropdown-menu
      class="notification-dropdown dropdown-custom vx-navbar-dropdown"
    >
      <div class="notification-top text-center p-5 bg-primary text-white">
        <h3 class="text-white">{{ unreadNotifications.length }} New</h3>
        <p class="opacity-75">System Notifications</p>
      </div>

      <VuePerfectScrollbar
        ref="mainSidebarPs"
        class="scroll-area--nofications-dropdown p-0 mb-10"
        :settings="settings"
        :key="$vs.rtl"
      >
        <ul class="bordered-items">
          <li
            v-for="ntf in unreadNotifications"
            :key="ntf.notification_id"
            @click="markAsRead(ntf.notification_id, ntf.notification_cta)"
            class="flex justify-between px-4 py-4 notification cursor-pointer"
          >
            <div class="flex items-start">
              <feather-icon
                :icon="notificationIcon(ntf.notification_type)"
                :svgClasses="[
                  `text-${notificationCategory(ntf.notification_type)}`,
                  'stroke-current mr-1 h-6 w-6',
                ]"
              ></feather-icon>
              <div class="mx-2">
                <span
                  class="font-medium block notification-title"
                  :class="[
                    `text-${notificationCategory(ntf.notification_type)}`,
                  ]"
                  >{{ ntf.notification_title }}</span
                >
                <small>{{ ntf.notification_content }}</small>
              </div>
            </div>
            <small class="mt-1 whitespace-no-wrap">{{
              elapsedTime(ntf.created_on)
            }}</small>
          </li>
        </ul>
      </VuePerfectScrollbar>

      <!-- <div class="
        checkout-footer
        fixed
        bottom-0
        rounded-b-lg
        text-primary
        w-full
        p-2
        font-semibold
        text-center
        border
        border-b-0
        border-l-0
        border-r-0
        border-solid
        d-theme-border-grey-light
        cursor-pointer">
        <span>View All Notifications</span>
      </div> -->
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";

export default {
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      ws: new WebSocket("wss://" + location.host + "/wsapp/"),
      unreadNotifications: [],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  created() {
    let that = this;
    const brand = location.host.split(".");
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    that.ws.onopen = function () {
      heartbeat;
      let message = JSON.stringify({
        type: "login",
        user: userInfo.name,
        brand: brand[1],
        token: userInfo.token,
      });
      that.ws.send(message);
    };
    that.ws.onmessage = function (evt) {
      var data = JSON.parse(evt.data);
      if (Array.isArray(data)) {
        for (let i in data) {
          that.unreadNotifications.push(data[i]);
        }
      } else that.unreadNotifications.push(data);
    };

    that.ws.onping = function () {
      heartbeat;
    };
    that.ws.onclose = function clear() {
      clearTimeout(this.pingTimeout);
    };

    function heartbeat() {
      clearTimeout(this.pingTimeout);
      this.pingTimeout = setTimeout(() => {
        this.terminate();
      }, 15000 + 1000);
    }
  },
  methods: {
    markAsRead: function (id, cta) {
      let that = this;
      let message = JSON.stringify({ type: "markAsRead", notification_id: id });
      that.ws.send(message);
      for (let i in that.unreadNotifications) {
        if (that.unreadNotifications[i].notification_id === id)
          that.unreadNotifications.splice(i, 1);
      }
      if (cta!==undefined && cta !== null && cta !== "") location.href = cta;
    },
    notificationIcon: function (type) {
      switch (type) {
        case 1:
          return "PackageIcon";
        case 2:
          return "AlertOctagonIcon";
        default:
          return "MessageSquareIcon";
      }
    },
    notificationCategory: function (type) {
      switch (type) {
        case 1:
          return "primary";
        case 2:
          return "danger";
        default:
          return "success";
      }
    },
    elapsedTime(startTime) {
      let x = new Date(startTime);
      let now = new Date();
      var timeDiff = now - x;
      timeDiff /= 1000;

      var seconds = Math.round(timeDiff);
      timeDiff = Math.floor(timeDiff / 60);

      var minutes = Math.round(timeDiff % 60);
      timeDiff = Math.floor(timeDiff / 60);

      var hours = Math.round(timeDiff % 24);
      timeDiff = Math.floor(timeDiff / 24);

      var days = Math.round(timeDiff % 365);
      timeDiff = Math.floor(timeDiff / 365);

      var years = timeDiff;

      if (years > 0) {
        return years + (years > 1 ? " Years " : " Year ") + "ago";
      } else if (days > 0) {
        return days + (days > 1 ? " Days " : " Day ") + "ago";
      } else if (hours > 0) {
        return hours + (hours > 1 ? " Hrs " : " Hour ") + "ago";
      } else if (minutes > 0) {
        return minutes + (minutes > 1 ? " Mins " : " Min ") + "ago";
      } else if (seconds > 0) {
        return seconds + (seconds > 1 ? " sec ago" : "just now");
      }

      return "Just Now";
    },
    // Method for creating dummy notification time
    randomDate({ hr, min, sec }) {
      let date = new Date();

      if (hr) date.setHours(date.getHours() - hr);
      if (min) date.setMinutes(date.getMinutes() - min);
      if (sec) date.setSeconds(date.getSeconds() - sec);

      return date;
    },
  },
};
</script>

